import React, {useEffect, useRef, useState} from 'react';
import {useIsFocused, useNavigation, useRoute} from '@react-navigation/native';
import Clipboard from '@react-native-clipboard/clipboard';
import {AppEventsLogger} from 'react-native-fbsdk-next';

import {BackHandler, Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';

import {Button} from '../../../components/Interface/Forms/Buttons/Button';
import {Header} from '../../../components/Interface/Headers/Header';

import {FocusAwareStatusBar} from '../../../context/statusbar';

import {
  Container,
  Content,
  IllustrationContainer,
  Illustration,
  TitleContent,
  Description,
  CopyButtonContainer,
  CopyButtonText,
  CopyText,
  InputGroup,
  CopyButton,
  Input,
  Icon,
  Footer,
} from './styles';
import {Toast} from '../../../components/Interface/Toast';
import {addInAppTrigger} from '../../../lib/pushMessaging';
import {rastrear} from '../../../services/rastrear';
import {SafeAreaView} from 'react-native-safe-area-context';
import { RootStackParamList } from '../../../dtos/RoutesDTO';


export function Pix() {
  const navigation = useNavigation();
  const route = useRoute();
  const screenIsFocus = useIsFocused();

  const [showToast, setShowToast] = useState(false);

  const {code, onConfirm} = route.params as RootStackParamList['Pix'];

  async function handleCompletePayment() {
    if (onConfirm) {
      onConfirm();
    } else {
      navigation.navigate('Coupons');
    }
  }

  useEffect(() => {
    AppEventsLogger.logEvent('compra_finalizada_pix');
  }, []);

  useEffect(() => {
    BackHandler.addEventListener('hardwareBackPress', function () {
      return false;
    });
  }, [screenIsFocus]);

  useEffect(() => {
    if (Platform.OS !== 'web') {
      addInAppTrigger('screen', 'pix');
    }
  }, []);

  const hasCalledRastrear = useRef(false);

  useEffect(() => {
    if (!screenIsFocus) {
      hasCalledRastrear.current = false;
      return;
    }
    if (hasCalledRastrear.current) {return;}
    hasCalledRastrear.current = true;
    rastrear({status_tela: 'copiaColaPix'});
  }, [screenIsFocus]);

  const copyToClipboard = () => {
    Clipboard.setString(code);
    setShowToast(true);
  };

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
      <Container>
        <FocusAwareStatusBar
          barStyle={Platform.OS === 'ios' ? 'dark-content' : 'light-content'}
        />
        <Header
          icon="chevron-left"
          action={() => navigation.navigate('Coupons')}
        />

        {showToast && (
          <Toast
            type="info"
            text="Código copiado"
            timeout={2000}
            onEnd={() => setShowToast(false)}
          />
        )}

        <Content>
          <IllustrationContainer>
            <Illustration
              //@ts-ignore
              width={RFValue(120)}
              height={RFValue(120)}
              uri="https://d3ag5cip9ldvh3.cloudfront.net/pix-illustration.svg"
            />
          </IllustrationContainer>
          <TitleContent>Aguardando pagamento</TitleContent>
          <Description>
            Copie o código abaixo e utilize a função Pix Copia e Cola no
            aplicativo do seu banco.
          </Description>

          <InputGroup>
            <Input value={code} editable={false} />
            <CopyButton onPress={copyToClipboard} activeOpacity={1}>
              <Icon name="copy-outline" />
            </CopyButton>
          </InputGroup>

          <CopyButtonContainer>
            <CopyButtonText onPress={copyToClipboard} activeOpacity={1}>
              <CopyText>Copiar código</CopyText>
            </CopyButtonText>
          </CopyButtonContainer>
        </Content>

        <Footer>
          <Button title="Continuar" enabled onPress={handleCompletePayment} />
        </Footer>
      </Container>
    </SafeAreaView>
  );
}
